/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  BatchDownloadStartResponse,
  BatchDownloadStatus,
  BatchUploadStartResponse,
  BatchUploadStatus,
  DataPipelineCount,
  DatasetDownloadNotFoundResponse,
  DatasetPipeline,
  DatasetPipelineBatchDownloadInput,
  DatasetPipelineCreate,
  DatasetPipelineDetail,
  DatasetPipelineProcess,
  PaginatedDatasetPipelineListList,
} from '../models/index';
import {
  BatchDownloadStartResponseFromJSON,
  BatchDownloadStartResponseToJSON,
  BatchDownloadStatusFromJSON,
  BatchDownloadStatusToJSON,
  BatchUploadStartResponseFromJSON,
  BatchUploadStartResponseToJSON,
  BatchUploadStatusFromJSON,
  BatchUploadStatusToJSON,
  DataPipelineCountFromJSON,
  DataPipelineCountToJSON,
  DatasetDownloadNotFoundResponseFromJSON,
  DatasetDownloadNotFoundResponseToJSON,
  DatasetPipelineFromJSON,
  DatasetPipelineToJSON,
  DatasetPipelineBatchDownloadInputFromJSON,
  DatasetPipelineBatchDownloadInputToJSON,
  DatasetPipelineCreateFromJSON,
  DatasetPipelineCreateToJSON,
  DatasetPipelineDetailFromJSON,
  DatasetPipelineDetailToJSON,
  DatasetPipelineProcessFromJSON,
  DatasetPipelineProcessToJSON,
  PaginatedDatasetPipelineListListFromJSON,
  PaginatedDatasetPipelineListListToJSON,
} from '../models/index';

export interface ApiDatasetPipelinesBatchDownloadAsyncCreateRequest {
  id: number;
  datasetPipelineBatchDownloadInput: DatasetPipelineBatchDownloadInput;
}

export interface ApiDatasetPipelinesBatchDownloadRetrieveRequest {
  id: number;
  includeOriginal: boolean;
  perturbations?: Array<number>;
}

export interface ApiDatasetPipelinesBatchDownloadStatusRetrieveRequest {
  id: number;
  taskId: string;
}

export interface ApiDatasetPipelinesBatchUploadAsyncCreateRequest {
  id: number;
  predictionsFile: Blob;
  documents?: Array<number>;
}

export interface ApiDatasetPipelinesBatchUploadCreateRequest {
  id: number;
  predictionsFile: Blob;
  documents?: Array<number>;
}

export interface ApiDatasetPipelinesBatchUploadPerturbedDatasetsCreateRequest {
  id: number;
  perturbedDatasetsFile: Blob;
  documents?: Array<number>;
}

export interface ApiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreateRequest {
  id: number;
  zipFile: Blob;
}

export interface ApiDatasetPipelinesBatchUploadStatusRetrieveRequest {
  id: number;
  taskId: string;
}

export interface ApiDatasetPipelinesCloneCreateRequest {
  id: number;
  datasetPipelineDetail?: Omit<
    DatasetPipelineDetail,
    | 'id'
    | 'aiModel'
    | 'generationInputs'
    | 'perturbations'
    | 'dataset'
    | 'perturbedDatasets'
    | 'progress'
    | 'startTime'
    | 'endTime'
    | 'estimatedTime'
    | 'errorMessage'
    | 'status'
    | 'timestamp'
    | 'assessments'
    | 'hasAssessments'
  >;
}

export interface ApiDatasetPipelinesCreateRequest {
  datasetPipelineCreate: DatasetPipelineCreate;
}

export interface ApiDatasetPipelinesDestroyRequest {
  id: number;
}

export interface ApiDatasetPipelinesListRequest {
  aiModelName?: Array<string>;
  endTimeAfter?: Date;
  endTimeBefore?: Date;
  errorMessage?: string;
  page?: number;
  pageSize?: number;
  startTimeAfter?: Date;
  startTimeBefore?: Date;
  status?: Array<ApiDatasetPipelinesListStatusEnum>;
  taskName?: string;
  taskType?: Array<ApiDatasetPipelinesListTaskTypeEnum>;
}

export interface ApiDatasetPipelinesProcessCreateRequest {
  id: number;
  datasetPipelineProcess: DatasetPipelineProcess;
}

export interface ApiDatasetPipelinesRetrieveRequest {
  id: number;
}

/**
 *
 */
export class DatasetPiplineApi extends runtime.BaseAPI {
  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchDownloadAsyncCreateRaw(
    requestParameters: ApiDatasetPipelinesBatchDownloadAsyncCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BatchDownloadStartResponse>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchDownloadAsyncCreate().',
      );
    }

    if (requestParameters['datasetPipelineBatchDownloadInput'] == null) {
      throw new runtime.RequiredError(
        'datasetPipelineBatchDownloadInput',
        'Required parameter "datasetPipelineBatchDownloadInput" was null or undefined when calling apiDatasetPipelinesBatchDownloadAsyncCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-download-async/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: DatasetPipelineBatchDownloadInputToJSON(requestParameters['datasetPipelineBatchDownloadInput']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => BatchDownloadStartResponseFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchDownloadAsyncCreate(
    requestParameters: ApiDatasetPipelinesBatchDownloadAsyncCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BatchDownloadStartResponse> {
    const response = await this.apiDatasetPipelinesBatchDownloadAsyncCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchDownloadRetrieveRaw(
    requestParameters: ApiDatasetPipelinesBatchDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchDownloadRetrieve().',
      );
    }

    if (requestParameters['includeOriginal'] == null) {
      throw new runtime.RequiredError(
        'includeOriginal',
        'Required parameter "includeOriginal" was null or undefined when calling apiDatasetPipelinesBatchDownloadRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['includeOriginal'] != null) {
      queryParameters['include_original'] = requestParameters['includeOriginal'];
    }

    if (requestParameters['perturbations'] != null) {
      queryParameters['perturbations'] = requestParameters['perturbations'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-download/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchDownloadRetrieve(
    requestParameters: ApiDatasetPipelinesBatchDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Blob> {
    const response = await this.apiDatasetPipelinesBatchDownloadRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchDownloadStatusRetrieveRaw(
    requestParameters: ApiDatasetPipelinesBatchDownloadStatusRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BatchDownloadStatus>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchDownloadStatusRetrieve().',
      );
    }

    if (requestParameters['taskId'] == null) {
      throw new runtime.RequiredError(
        'taskId',
        'Required parameter "taskId" was null or undefined when calling apiDatasetPipelinesBatchDownloadStatusRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['taskId'] != null) {
      queryParameters['task_id'] = requestParameters['taskId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-download-status/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => BatchDownloadStatusFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchDownloadStatusRetrieve(
    requestParameters: ApiDatasetPipelinesBatchDownloadStatusRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BatchDownloadStatus> {
    const response = await this.apiDatasetPipelinesBatchDownloadStatusRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadAsyncCreateRaw(
    requestParameters: ApiDatasetPipelinesBatchUploadAsyncCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BatchUploadStartResponse>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchUploadAsyncCreate().',
      );
    }

    if (requestParameters['predictionsFile'] == null) {
      throw new runtime.RequiredError(
        'predictionsFile',
        'Required parameter "predictionsFile" was null or undefined when calling apiDatasetPipelinesBatchUploadAsyncCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['predictionsFile'] != null) {
      formParams.append('predictions_file', requestParameters['predictionsFile'] as any);
    }

    if (requestParameters['documents'] != null) {
      requestParameters['documents'].forEach(element => {
        formParams.append('documents', element as any);
      });
    }

    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-upload-async/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => BatchUploadStartResponseFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadAsyncCreate(
    requestParameters: ApiDatasetPipelinesBatchUploadAsyncCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BatchUploadStartResponse> {
    const response = await this.apiDatasetPipelinesBatchUploadAsyncCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadCreateRaw(
    requestParameters: ApiDatasetPipelinesBatchUploadCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPipelineDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchUploadCreate().',
      );
    }

    if (requestParameters['predictionsFile'] == null) {
      throw new runtime.RequiredError(
        'predictionsFile',
        'Required parameter "predictionsFile" was null or undefined when calling apiDatasetPipelinesBatchUploadCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['predictionsFile'] != null) {
      formParams.append('predictions_file', requestParameters['predictionsFile'] as any);
    }

    if (requestParameters['documents'] != null) {
      requestParameters['documents'].forEach(element => {
        formParams.append('documents', element as any);
      });
    }

    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-upload/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPipelineDetailFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadCreate(
    requestParameters: ApiDatasetPipelinesBatchUploadCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPipelineDetail> {
    const response = await this.apiDatasetPipelinesBatchUploadCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadPerturbedDatasetsCreateRaw(
    requestParameters: ApiDatasetPipelinesBatchUploadPerturbedDatasetsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPipelineDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchUploadPerturbedDatasetsCreate().',
      );
    }

    if (requestParameters['perturbedDatasetsFile'] == null) {
      throw new runtime.RequiredError(
        'perturbedDatasetsFile',
        'Required parameter "perturbedDatasetsFile" was null or undefined when calling apiDatasetPipelinesBatchUploadPerturbedDatasetsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['perturbedDatasetsFile'] != null) {
      formParams.append('perturbed_datasets_file', requestParameters['perturbedDatasetsFile'] as any);
    }

    if (requestParameters['documents'] != null) {
      requestParameters['documents'].forEach(element => {
        formParams.append('documents', element as any);
      });
    }

    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-upload-perturbed-datasets/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPipelineDetailFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadPerturbedDatasetsCreate(
    requestParameters: ApiDatasetPipelinesBatchUploadPerturbedDatasetsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPipelineDetail> {
    const response = await this.apiDatasetPipelinesBatchUploadPerturbedDatasetsCreateRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreateRaw(
    requestParameters: ApiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPipelineDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreate().',
      );
    }

    if (requestParameters['zipFile'] == null) {
      throw new runtime.RequiredError(
        'zipFile',
        'Required parameter "zipFile" was null or undefined when calling apiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['zipFile'] != null) {
      formParams.append('zip_file', requestParameters['zipFile'] as any);
    }

    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-upload-perturbed-datasets-zip/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPipelineDetailFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreate(
    requestParameters: ApiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPipelineDetail> {
    const response = await this.apiDatasetPipelinesBatchUploadPerturbedDatasetsZipCreateRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadStatusRetrieveRaw(
    requestParameters: ApiDatasetPipelinesBatchUploadStatusRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BatchUploadStatus>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesBatchUploadStatusRetrieve().',
      );
    }

    if (requestParameters['taskId'] == null) {
      throw new runtime.RequiredError(
        'taskId',
        'Required parameter "taskId" was null or undefined when calling apiDatasetPipelinesBatchUploadStatusRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['taskId'] != null) {
      queryParameters['task_id'] = requestParameters['taskId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/batch-upload-status/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => BatchUploadStatusFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesBatchUploadStatusRetrieve(
    requestParameters: ApiDatasetPipelinesBatchUploadStatusRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BatchUploadStatus> {
    const response = await this.apiDatasetPipelinesBatchUploadStatusRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesCloneCreateRaw(
    requestParameters: ApiDatasetPipelinesCloneCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPipelineDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesCloneCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/clone/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: DatasetPipelineDetailToJSON(requestParameters['datasetPipelineDetail']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPipelineDetailFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesCloneCreate(
    requestParameters: ApiDatasetPipelinesCloneCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPipelineDetail> {
    const response = await this.apiDatasetPipelinesCloneCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesCountsRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DataPipelineCount>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/counts/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DataPipelineCountFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesCountsRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DataPipelineCount> {
    const response = await this.apiDatasetPipelinesCountsRetrieveRaw(initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesCreateRaw(
    requestParameters: ApiDatasetPipelinesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPipeline>> {
    if (requestParameters['datasetPipelineCreate'] == null) {
      throw new runtime.RequiredError(
        'datasetPipelineCreate',
        'Required parameter "datasetPipelineCreate" was null or undefined when calling apiDatasetPipelinesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: DatasetPipelineCreateToJSON(requestParameters['datasetPipelineCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPipelineFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesCreate(
    requestParameters: ApiDatasetPipelinesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPipeline> {
    const response = await this.apiDatasetPipelinesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesDestroyRaw(
    requestParameters: ApiDatasetPipelinesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesDestroy(
    requestParameters: ApiDatasetPipelinesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiDatasetPipelinesDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesListRaw(
    requestParameters: ApiDatasetPipelinesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedDatasetPipelineListList>> {
    const queryParameters: any = {};

    if (requestParameters['aiModelName'] != null) {
      queryParameters['ai_model_name'] = requestParameters['aiModelName'];
    }

    if (requestParameters['endTimeAfter'] != null) {
      queryParameters['end_time_after'] = (requestParameters['endTimeAfter'] as any).toISOString();
    }

    if (requestParameters['endTimeBefore'] != null) {
      queryParameters['end_time_before'] = (requestParameters['endTimeBefore'] as any).toISOString();
    }

    if (requestParameters['errorMessage'] != null) {
      queryParameters['error_message'] = requestParameters['errorMessage'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['startTimeAfter'] != null) {
      queryParameters['start_time_after'] = (requestParameters['startTimeAfter'] as any).toISOString();
    }

    if (requestParameters['startTimeBefore'] != null) {
      queryParameters['start_time_before'] = (requestParameters['startTimeBefore'] as any).toISOString();
    }

    if (requestParameters['status'] != null) {
      queryParameters['status'] = requestParameters['status'];
    }

    if (requestParameters['taskName'] != null) {
      queryParameters['task_name'] = requestParameters['taskName'];
    }

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedDatasetPipelineListListFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesList(
    requestParameters: ApiDatasetPipelinesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedDatasetPipelineListList> {
    const response = await this.apiDatasetPipelinesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesProcessCreateRaw(
    requestParameters: ApiDatasetPipelinesProcessCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPipelineProcess>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesProcessCreate().',
      );
    }

    if (requestParameters['datasetPipelineProcess'] == null) {
      throw new runtime.RequiredError(
        'datasetPipelineProcess',
        'Required parameter "datasetPipelineProcess" was null or undefined when calling apiDatasetPipelinesProcessCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/process/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: DatasetPipelineProcessToJSON(requestParameters['datasetPipelineProcess']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPipelineProcessFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesProcessCreate(
    requestParameters: ApiDatasetPipelinesProcessCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPipelineProcess> {
    const response = await this.apiDatasetPipelinesProcessCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesRetrieveRaw(
    requestParameters: ApiDatasetPipelinesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DatasetPipelineDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDatasetPipelinesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dataset-pipelines/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DatasetPipelineDetailFromJSON(jsonValue));
  }

  /**
   * Dataset pipelines. Create an inferencer first (``POST /api/inferencers/single_turn_chat/`` or ``POST /api/inferencers/conversational-agent/``), then pass ``inferencer_id`` (the returned id) when creating a pipeline. The key ``inferencer`` is accepted as an alias for ``inferencer_id``.
   */
  async apiDatasetPipelinesRetrieve(
    requestParameters: ApiDatasetPipelinesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DatasetPipelineDetail> {
    const response = await this.apiDatasetPipelinesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ApiDatasetPipelinesListStatusEnum = {
  cancelled: 'cancelled',
  completed: 'completed',
  failed: 'failed',
  pending: 'pending',
  running: 'running',
} as const;
export type ApiDatasetPipelinesListStatusEnum =
  (typeof ApiDatasetPipelinesListStatusEnum)[keyof typeof ApiDatasetPipelinesListStatusEnum];
/**
 * @export
 */
export const ApiDatasetPipelinesListTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiDatasetPipelinesListTaskTypeEnum =
  (typeof ApiDatasetPipelinesListTaskTypeEnum)[keyof typeof ApiDatasetPipelinesListTaskTypeEnum];
